/// <reference types="google.maps" />
import { importLibrary } from '@googlemaps/js-api-loader';

import { formatGeocodeResponse } from './geocoderHelpers';
import type { GeocodingResult } from './types';

type GeocodeParams = {
  /** Initializer stub that replaces the v1 JS api loader. This should be a function that sets the Google API options. */
  loader: () => void;
  /** The address to look up. */
  searchCriteria: string;
};

export const GEOCODE_ZERO_RESULTS =
  'ZERO_RESULTS' as const satisfies `${google.maps.GeocoderStatus.ZERO_RESULTS}`;

/**
 * Given an address, retrieve Google Maps address components parsed into a Geocoding result.
 */
export const geocode = async ({
  loader,
  searchCriteria,
}: GeocodeParams): Promise<GeocodingResult> => {
  loader();

  const { Geocoder } = await importLibrary('geocoding');
  const geocoder = new Geocoder();

  return new Promise((resolve, reject) => {
    geocoder.geocode({ address: searchCriteria }, (results, status) => {
      if (status !== 'OK') {
        return reject(new Error(status));
      }
      if (!results || results.length === 0) {
        return reject(new Error(GEOCODE_ZERO_RESULTS));
      }

      resolve(formatGeocodeResponse(results[0]));
    });
  });
};
